export default function clamp(number: number, lower: number, upper: number): number {
	return Math.min(Math.max(+number || 0, lower), upper);
}